import 'ol/ol.css';
import LayerGroup from 'ol/layer/Group';
import FeatureDrawer from "../helpers/FeatureDrawer";
import MapElement from './MapElement';
import MapChangesChild from './MapChangesChild.js';


export default class MapChanges extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent)
    }

    drawLayer(data, projection) {
        if (data != null) {
            this.layer = new LayerGroup();
            console.log(data);

            var ChildSettings = { clickmethod: this.mapElementSettings.clickmethod, interactable: true, group: true, defaultOn: true }

            data.actions.forEach((action) => {
                if (action.action == "connectlines") {
                    var childLayer = new MapChangesChild(this.mapModel, "CONNECTEDLINES", ChildSettings, this, projection);
                    childLayer.drawLayer(action);
                    this.mapElements.push(childLayer);
                }
                else if (action.action == "disconnectlines") {
                    var childLayer = new MapChangesChild(this.mapModel, "DISCONNECTEDLINES", ChildSettings, this, projection);
                    childLayer.drawLayer(action);
                    this.mapElements.push(childLayer);
                }
            });

            console.log(this.parent);
            this.parent.layer.getLayers().push(this.layer);

            if (!this.mapElementSettings.defaultOn) {
                this.hide();
            }
        }
    }

    clear() {
        if (this.mapElements.length > 0) {
            this.mapElements.forEach(element => {
                element.clear();
            })
        }

        this.layer = null;
        this.mapElements = [];
    }
}